import { render } from "./UserDetailsComponent.vue?vue&type=template&id=350dd8fc&scoped=true"
import script from "./UserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./UserDetailsComponent.vue?vue&type=script&lang=js"

import "./UserDetailsComponent.vue?vue&type=style&index=0&id=350dd8fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350dd8fc"]])

export default __exports__